import { Component, Inject, OnDestroy, OnInit, ViewChild ,NgZone } from '@angular/core';
import _ from 'lodash';
import { ClipboardService } from 'ngx-clipboard';
import {mySynchModules} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { MySynchEnumerationService } from "../../services/mysynch.enumeration.service";
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import {PageTrackerService} from '../../services/page-tracker.service';
import { PerformanceContextService } from '../../services/performance-context.service';

import { Herd, Farm, PerformanceContext } from '../../interfaces/mysynch.interfaces';
@Component({
  standalone: false,
  selector: 'herd-data',
  templateUrl: '../app/pages/herd-data/herd-data.view.html',
  styleUrls:['../app/pages/herd-data/herd-data.style.css']
})
export class HerdData implements OnInit , OnDestroy {

    private copyButtonClicked: boolean = false;
    private herdChangeSubscription: any = null;
    private performanceContext: PerformanceContext | null = null;

    mySynchModules: any = mySynchModules;

    loading: boolean = true;
    herdManagementSoftwares: any[] = [
        {
            name: "DC305",
            value: 1,
            text: 'DairyComp 305'
        }
    ];
    selectedSoftware: any =  this.herdManagementSoftwares[0];
    herd: Herd | null = null;
    herdUploads: any[] = [];
    alertStyles:any = {
        1: 'alert-info',
        2: 'alert-success',
        3: 'alert-danger',
        4: 'alert-warning'
    };
    isWinXP: boolean = _.includes(navigator.userAgent.toLowerCase(), 'windows nt 5.1');
    
    dataFeederLink: string 


    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject(PageTrackerService) private pageTracker:PageTrackerService,
				@Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(NgZone) private ngZone:NgZone,
                @Inject(ClipboardService) private clipboardService:ClipboardService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
            ) {
               
            }

    ngOnInit() {
        
        this.MSF.ready(()=>{
            this.dataFeederLink =  '../../downloads/' + (this.mySynchModules.config.dataFeeder ? this.mySynchModules.config.dataFeeder + '_' : '') + 'MySynch.Client.exe';
            const personKey = _.get(this.MSF,'cookies.user.PersonKey') as string;
            let herdKey = _.get(this.MSF,'activeHerd.herdKey') as string;

            if (!herdKey) {
                herdKey = _.get(this.MSF,'cookies.state.activeFarm.herds[0].herdKey') as string;
            }

            if (personKey && herdKey) {
                this.pageTracker.trackPageView(personKey, herdKey, '(Herd Data Tab)');	// no need to pass a callback because this is fire and forget
            }
            this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.MSF.getActiveHerd(), 'herdId', null));

            this.perfMetricSvc.startTiming('Page:FarmUploads:Render');
            document.addEventListener('copy', this.handleCopyEvent);

            this.getHerdData().then(() => {
                this.perfMetricSvc.markPageReady('Page:FarmUploads:Render', this.performanceContext);
            });

            this.herdChangeSubscription = this.mysynchDataStore.currentActiveHerd
                .subscribe((herd)=>{
                    if(!_.isUndefined(herd) && this.loading === false){
                        this.loading = true;
                        this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(herd, 'herdId', null));
                        this.perfMetricSvc.startTiming('Page:FarmUploadsOnHerdChange:Render');
                        this.getHerdData().then(() => {
                            this.perfMetricSvc.markPageReady('Page:FarmUploadsOnHerdChange:Render', this.performanceContext);
                        });
                    }
                });

        });

        
                 
    }


    ngOnDestroy() {
        console.log('FarmUploadsController: $destroy');
        if (this.herdChangeSubscription) {
            this.herdChangeSubscription.unsubscribe();
        }
        document.removeEventListener('copy', this.handleCopyEvent);
        this.performanceContext = null;
    }

    private getHerdData() {
        return new Promise<void>((resolve, reject) => {
            
            this.herd = this.MSF.getActiveHerd() as Herd;
           

            this.perfMetricSvc.startTiming('Page:FarmUploadsPageData:Request');
            this.api.getHerdUploadsByHerdId(this.herd.herdId, this.performanceContext, (err: any, herdUploads: any[]) => {
                this.perfMetricSvc.endTiming("page",'Page:FarmUploadsPageData:Request', this.performanceContext);
                this.perfMetricSvc.startTiming('Page:FarmUploadsPageData:Build');
                

                if (err) {
                    this.log.error('error getting herdUploads');
                }


                this.herdUploads = herdUploads;
                this.perfMetricSvc.endTiming("page",'Page:FarmUploadsPageData:Build', this.performanceContext);
                this.loading = false;
                resolve();
            });
        });
    }
    private handleCopyEvent = (e:any) => {
        this.ngZone.run(() => {
            if (!this.copyButtonClicked) {
                const selection = window.getSelection();
                const selectedText = selection ? selection.toString().trim() : '';
                if (e.clipboardData && selectedText) {
                    e.clipboardData.setData('text/plain', selectedText);
                    e.preventDefault();
                }
            }
            this.copyButtonClicked = false;
        });
    }
    
    
    canUpdate() {
        return this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission','HERD_DATA_UPDATE'));
    };
    
    onCopyToClipboard(){
        this.copyButtonClicked = true;
    
        if (this.herd?.herdKey) {
            this.clipboardService.copy(this.herd.herdKey);
            this.MSF.notify.success("The Herd Key was successfully copied to the clipboard!");
        } 
    }

   

    

}